import React, { useState, useEffect, useRef } from "react";

import { BlobToDownloadFile } from "../../../helper/commanFunction";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../../services/reports-Diamond.service";

import { useSelector } from "react-redux";
import moment from "moment";
import { Button, DatePicker, Select, Spin, Table, Tooltip } from "antd";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Chart from "react-google-charts";
import logoImg from "../../../../src/assets/images/logo-img.png";
import { chartColors } from "../../reports/colors";

const { RangePicker } = DatePicker;
const { Option } = Select;

const DiamondReportsShapeIndComp = () => {
  const { t } = useTranslation();
  const DiamondShapeChartRef = useRef();
  /*Initial State for Binding Starts*/
  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  /*Initial State for Binding Ends*/

  /*React Binding Starts*/
  const [TableForAllList, setTableForAllList] = useState([]);
  const [globalDiamonds, setGlobalDiamond] = useState(
    initialGlobalDiamondState
  );
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [TableForAllLoading, setTableForAllLoading] = useState(false);
  const [TotalDiamondClicks, setTotalDiamondClicks] = useState(0);
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const loginDetials = useSelector((state) => state.loginReducer);
  const [diamondShapeSearchesLabels, setDiamondShapeSearchesLabels] = useState(
    []
  );
  const [DiamondShapeSearchesList, setDiamondShapeSearchesList] = useState([]);
  const [DiamondShapeColorData, setDiamondShapeColorData] = useState([]);
  const [DiamondShapeYAxisList, setDiamondShapeYAxisList] = useState([]);
  const [TableShapeValue, setTableShapeValue] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [sortType, setSortType] = useState("desc");
  const [sortColumnName, setSortColumnName] = useState("GT.MODIFIED");
  const [key, setKey] = useState(true);
  const [paginationPage, setPaginationPage] = useState(1);
  const [downloadCSVDataloading, setDownloadCSVDataloading] = useState(false);
  /*React Binding Ends*/

  /*DatePicker Binding Starts*/
  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };
  /*DatePicker Binding Ends*/
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    if (TableShapeValue) {
      handleGetDiamondReportForTableChartAll(
        dealerId,
        forDealer,
        TableShapeValue,
        1,
        pageSize
      );
    }
  }, [TableShapeValue]);

  /*API Binding Starts*/
  const handleCheckDealermembers = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };

      ReportsDiamondService.CheckDealermembers(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;

          // Calculate forDealer based on dealerMemberTypeName
          let forDealer;
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "VendorDiamond" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
          ) {
            forDealer = 1;
          } else if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "Retailer" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Combined"
          ) {
            forDealer = 2;
          } else {
            forDealer = 3;
          }

          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setForDealer(forDealer);
            } else {
              setForDealer("");
            }
            handleLoadExtendedDiamondChartReports(id, forDealer);
            handleGetDiamondReportForTableChartAll(
              id,
              forDealer,
              "",
              pageNo,
              pageSize,
              sortColumnName,
              sortType
            );
          } else {
            setForDealer("");
          }
        })
        .catch((error) => {
          setForDealer("");
        });
    } catch (error) {
      setForDealer("");
    }
  };

  const handleLoadExtendedDiamondChartReports = (dealerId, forDealer) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorDiamond"
      ) {
        forDealer = 1;
      }
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: globalDiamonds.retailerIds.toString(),
        vendorIds: globalDiamonds.vendorIds.toString(),
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        reportName: "Cut",
      };
      setLoadChartReportsLoading(true);

      ReportsDiamondService.LoadExtendedDiamondChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var DiamondShapeSearchesList = responseData.DiamondShapeSearches;
          var TotalDiamondClicks =
            responseData.TotalDiamondClicks[0].TotalClickCnt;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setTotalDiamondClicks(TotalDiamondClicks);
              setDiamondShapeSearchesList(DiamondShapeSearchesList);
              var DiamondShapeSearchesLabelArr = DiamondShapeSearchesList.map(
                (item) => {
                  return item.Cut;
                }
              );
              var DiamondShapeYAxisList = DiamondShapeSearchesList.map(
                (item) => {
                  return item.CNT;
                }
              );
              setDiamondShapeSearchesLabels(DiamondShapeSearchesLabelArr);
              setDiamondShapeYAxisList(DiamondShapeYAxisList);
              diamondShapeColorHandler(DiamondShapeSearchesLabelArr);
              setKey(!key);
            }
          } else {
            setTotalDiamondClicks(0);
            setDiamondShapeSearchesList([]);
            setDiamondShapeYAxisList([]);
          }
        })
        .catch((error) => {
          setTotalDiamondClicks(0);
          setDiamondShapeSearchesList([]);
          setLoadChartReportsLoading(false);
          setDiamondShapeYAxisList([]);
          setDiamondShapeSearchesLabels([]);
        });
    } catch (error) {
      setTotalDiamondClicks(0);
      setDiamondShapeSearchesList([]);
      setLoadChartReportsLoading(false);
      setDiamondShapeYAxisList([]);
      setDiamondShapeSearchesLabels([]);
    }
  };
  const handleGetDiamondReportForTableChartAll = (
    dealerId,
    forDealer,
    shapeValue,
    pageNo,
    pageSize,
    sortColumnName,
    sortOrder
  ) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorDiamond"
      ) {
        forDealer = 1;
      }
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        clarity: "",
        cutGrade: "",
        shape: shapeValue.toString(),
        color: "",
        size: "",
        certificate: "",
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        pageNumber: pageNo ? pageNo : 1,
        pageSize: pageSize ? pageSize : 15,
        sortOrderCol: sortColumnName || "GT.MODIFIED",
        sortOrderType: sortOrder || "DESC",
        reportName: "Cut",
      };
      setTableForAllLoading(true);

      ReportsDiamondService.GetDiamondReportForTableChartAll(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var TableForAllList = responseData.modelTableChartAllList;
          var TotalEventsCount = responseData.totalCount;
          setTableForAllLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setTotalCount(TotalEventsCount);
              setTableForAllList(TableForAllList);
            }
          } else {
            setTotalCount(0);
            setTableForAllList([]);
          }
        })
        .catch((error) => {
          setTotalCount(0);
          setTableForAllList([]);
          setTableForAllLoading(false);
        });
    } catch (error) {
      setTotalCount(0);
      setTableForAllList([]);
      setTableForAllLoading(false);
    }
  };

  const handleExportToCSV = (shapeValue, sortOrder, forDealer) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorDiamond"
      ) {
        forDealer = 1;
      }
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        clarity: "",
        cutGrade: "",
        shape: shapeValue ? shapeValue.toString() : "",
        color: "",
        size: "",
        certificate: "",
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        pageNumber: pageNo ? pageNo : 1,
        pageSize: pageSize ? pageSize : 15,
        sortOrderCol: sortColumnName || "GT.MODIFIED",
        sortOrderType: sortOrder || "ASC",
        reportName: "Cut",
      };
      setDownloadCSVDataloading(true);
      ReportsDiamondService.ExportDataToCSV(inputData)
        .then((response) => {
          setDownloadCSVDataloading(false);
          var fileName =
            loginDetials.loginDetials.responseData.dealerCompany.replace(/\s+/g, "") +
            "_DiamondShapeReports_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".csv";
          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
          console.log(error);
        });
    } catch (error) {
      setDownloadCSVDataloading(false);
      console.log(error);
    }
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "DESC";
      column = "GT.MODIFIED";
      setSortColumnName(column);
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetDiamondReportForTableChartAll(
      dealerId,
      forDealer,
      TableShapeValue,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };
  /*API Binding Ends*/

  const diamondShapeColorHandler = (list) => {
    const color = [];
    const colors = list.map(
      (_, index) => chartColors[index % chartColors.length]
    );
    setDiamondShapeColorData(colors);
  };
  const handleOnChange = (e, isSelect, name) => {
    setGlobalDiamond({
      ...globalDiamonds,
      [name]: e,
    });
  };

  const handleApplyFilter = () => {
    setPageNo(1);
    setPageSize(15);
    handleLoadExtendedDiamondChartReports(dealerId, forDealer);
    handleGetDiamondReportForTableChartAll(dealerId, forDealer, "", 1, 15);
  };

  const chartData = [
    ["Shape", "Count", { role: "style" }, { role: "annotation" }],
    ...diamondShapeSearchesLabels.map((label, index) => {
      const value = DiamondShapeYAxisList[index];
      const color = DiamondShapeColorData[index];
      return [label, value, color, value]; // value used as annotation
    }),
  ];

  const options = {
    legend: { position: "none" },
    bar: { groupWidth: "40%" },
    chartArea: { left: 40, top: 80, bottom: 70, width: "90%", height: "80%" }, // add space for legend
    hAxis: {
      title: "Shape",
      textStyle: { fontSize: 18, bold: true, color: "#424242" },
      titleTextStyle: { color: "rgb(66, 66, 66)", fontSize: 22, bold: true },
    },
    vAxis: {
      title: "Click",
      textStyle: { fontSize: 18, bold: true, color: "#424242" },
      titleTextStyle: { color: "rgb(66, 66, 66)", fontSize: 22, bold: true },
    },
    annotations: {
      alwaysOutside: true,
      textStyle: {
        fontSize: 16,
        bold: true,
        color: "#000",
      },
    },
  };

  const handleChartClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = chartData[selectedItem.row + 1][0];
      const value = chartData[selectedItem.row + 1][1];
      setTableShapeValue(label);
      setPaginationPage(1);
    }
  };


  const handleDownloadBarChart = async () => {
    try {
      // Step 1: Prepare enhanced chart options for export
      const pdfChartOptions = {
        ...options,
        width: 1800, // use full width for better readability
        height: 1000,
        chartArea: {
          left: 80,
          top: 140, // more space for legend above
          bottom: 220, // increased bottom space for full shape names
          width: "85%",
          height: "55%",
        },
        hAxis: {
          ...options.hAxis,
          slantedText: true,
          slantedTextAngle: 60, // increased angle for better text visibility
          textStyle: { fontSize: 14, color: "#333" },
          maxTextLines: 3, // allow multiple lines for long names
          maxAlternation: 1,
        },
        vAxis: {
          ...options.vAxis,
          textStyle: { fontSize: 15, color: "#333" },
        },
        annotations: {
          ...options.annotations,
          textStyle: { fontSize: 15, bold: true, color: "#000" },
        },
      };

      // Step 2: Create hidden container
      const hiddenContainer = document.createElement("div");
      hiddenContainer.id = "pdf-temp-chart";
      hiddenContainer.style.position = "absolute";
      hiddenContainer.style.left = "-9999px";
      hiddenContainer.style.top = "0";
      hiddenContainer.style.width = "1800px";
      hiddenContainer.style.background = "#fff";
      hiddenContainer.style.padding = "20px";
      document.body.appendChild(hiddenContainer);

      // Step 3: Build custom legend (larger + full width)
      const legendDiv = document.createElement("div");
      legendDiv.style.display = "flex";
      legendDiv.style.flexWrap = "wrap";
      legendDiv.style.justifyContent = "space-evenly"; // evenly spaced full width
      legendDiv.style.marginBottom = "20px";
      legendDiv.style.fontFamily = "Arial, sans-serif";
      legendDiv.style.width = "100%";

      diamondShapeSearchesLabels.forEach((label, index) => {
        const item = document.createElement("div");
        item.style.display = "flex";
        item.style.alignItems = "center";
        item.style.margin = "8px 16px";
        item.style.fontSize = "18px"; // larger font
        item.style.fontWeight = "bold";
        item.style.whiteSpace = "nowrap";

        const colorBox = document.createElement("div");
        colorBox.style.width = "18px";
        colorBox.style.height = "18px";
        colorBox.style.backgroundColor = DiamondShapeColorData[index];
        colorBox.style.marginRight = "8px";
        colorBox.style.border = "1px solid #aaa";
        colorBox.style.borderRadius = "3px";

        const textNode = document.createTextNode(
          `${label} (${DiamondShapeYAxisList[index]})`
        );

        item.appendChild(colorBox);
        item.appendChild(textNode);
        legendDiv.appendChild(item);
      });

      hiddenContainer.appendChild(legendDiv);

      // Step 4: Add chart container
      const chartDiv = document.createElement("div");
      chartDiv.style.width = "1800px";
      chartDiv.style.height = "1000px";
      hiddenContainer.appendChild(chartDiv);

      // Step 5: Draw chart
      const tempChart = new window.google.visualization.ColumnChart(chartDiv);
      const dataTable = window.google.visualization.arrayToDataTable(chartData);
      await new Promise((resolve) => {
        window.google.visualization.events.addListener(tempChart, "ready", resolve);
        tempChart.draw(dataTable, pdfChartOptions);
      });

      // Step 6: Capture legend + chart together
      const canvas = await html2canvas(hiddenContainer, {
        useCORS: true,
        scale: 2.8,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/png");

      // Step 7: Clean up
      document.body.removeChild(hiddenContainer);

      // Step 8: Create PDF
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const headerHeight = 14;
      const footerHeight = 10;
      const infoBlockHeight = 20;
      const availableHeight =
        pageHeight - headerHeight - footerHeight - infoBlockHeight - 10;

      // Header
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, 0, pageWidth, headerHeight, "F");
      try {
        pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
      } catch { }

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(255, 255, 255);
      pdf.text("DIAMOND SHAPE SEARCH REPORT", pageWidth - margin, 11, {
        align: "right",
      });

      // Info line
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(globalDiamonds.dataRangeFrom).format(
        "MMM DD, YYYY"
      )} - ${moment(globalDiamonds.dataRangeTo).format("MMM DD, YYYY")}`;

      const selectedDiamondLabel =
        globalDiamonds.SelectedDiamondValue === "All"
          ? "All Diamonds"
          : globalDiamonds.SelectedDiamondValue === "Mined"
            ? "Mined Diamonds"
            : "Lab Grown Diamonds";

      const diamondType = `Selected Diamond: ${selectedDiamondLabel}`;
      const clicks = `Total Clicks: ${TotalDiamondClicks?.toLocaleString() || 0}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        diamondType,
        clicks
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // Split text dynamically to fit within the maxWidth
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      // Display each line with proper spacing
      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;

      // Chart + Legend image
      const imgRatio = canvas.width / canvas.height;
      let imgWidthMM = pageWidth - margin * 3;
      let imgHeightMM = imgWidthMM / imgRatio;
      if (imgHeightMM > availableHeight) {
        imgHeightMM = availableHeight;
        imgWidthMM = imgHeightMM * imgRatio;
      }

      const xPos = margin;
      const yPos = currentY; 
      pdf.addImage(imgData, "PNG", xPos, yPos, imgWidthMM, imgHeightMM, undefined, "FAST");

      // Footer
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFont("helvetica", "italic");
      pdf.setFontSize(8);
      const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
        "MMM DD, YYYY h:mm A"
      )}`;
      pdf.text(footerText, pageWidth / 2, pageHeight - footerHeight / 2 + 2, {
        align: "center",
      });

      // --- WATERMARK ---
        const watermarkText = "JewelCloud";
        pdf.setFontSize(90);
        pdf.setFont(undefined, "bolditalic");
        pdf.setTextColor(102, 102, 102);

        pdf.saveGraphicsState();
        pdf.setGState(pdf.GState({ opacity: 0.1 }));

        const centerX = pageWidth / 2;
        const centerY = pageHeight / 2;

        const textWidth = pdf.getTextWidth(watermarkText);
        const textHeight =
          pdf.internal.getFontSize() / pdf.internal.scaleFactor;

        const angleRad = (45 * Math.PI) / 180;
        const rotatedWidth =
          textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
        const rotatedHeight =
          textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);

        const xPosWatermark = centerX - rotatedWidth / 2;
        const yPosWatermark = centerY + rotatedHeight / 4 + 40;

        pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });

        pdf.restoreGraphicsState();

      pdf.save("Diamond-Shape-Search-Report.pdf");
    } catch (err) {
      console.error("Error generating PDF:", err);
    }
  };




  return (
    <React.Fragment>
      <div className="form__fields magento__mapping">
        <div className="row">
          <div className="col-lg-12 mt-4">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Diamond Shape Searches")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block dataRange-input-block datepicker__block">
              <label> {t("Date Range")} </label>
              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block">
              <label> {t("Select Diamond")} </label>
              <Select
                className="border__grey"
                placeholder={t("All")}
                showSearch
                name="SelectedDiamondValue"
                optionFilterProp="children"
                value={
                  globalDiamonds.SelectedDiamondValue
                    ? globalDiamonds.SelectedDiamondValue
                    : null
                }
                onChange={(e) =>
                  handleOnChange(e, "select", "SelectedDiamondValue")
                }
              >
                <Option value="All">{t("All")}</Option>
                <Option value="Mined">{t("Mined Diamond")}</Option>
                <Option value="Lab">{t("Lab Grown Diamond")}</Option>
              </Select>
            </div>
          </div>

          {TableForAllList &&
            TableForAllList.length > 0 &&
            DiamondShapeSearchesList.length > 0 && (
              <div className="col-lg-12 col-md-6">
                <div className="input__block">
                  <label>
                    <Spin spinning={LoadChartReportsLoading} size="small">
                      <b>
                        {" "}
                        {t("Total Clicks")} :{" "}
                        {totalCount ? totalCount : 0}
                      </b>
                    </Spin>
                  </label>
                </div>
              </div>
            )}

          <div className="col-md-12 mt-2">
            <div className="button__block mb-4">
              <button className="primary-btn mr-2" onClick={handleApplyFilter}>
                {" "}
                {t("Apply Filter")}{" "}
              </button>
            </div>
          </div>
          <div className="chart__section">
            <Spin spinning={LoadChartReportsLoading} size="large">
              {TableForAllList && TableForAllList.length > 0 ? (
                <div id="pdf-content-bar-chart">
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      marginBottom: "10px",
                    }}
                  >
                    {diamondShapeSearchesLabels.map((label, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: "0 10px",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        <div
                          style={{
                            width: "14px",
                            height: "14px",
                            backgroundColor: DiamondShapeColorData[index],
                            marginRight: "6px",
                          }}
                        ></div>
                        {label} ({DiamondShapeYAxisList[index]})
                      </div>
                    ))}
                  </div>

                  <Chart
                    chartType="ColumnChart"
                    data={chartData}
                    options={options}
                    width={window.innerWidth > 500 ? "100%" : 300}
                    height={window.innerWidth > 500 ? 600 : 300}
                    chartEvents={[
                      {
                        eventName: "select",
                        callback: handleChartClick,
                      },
                    ]}
                  />
                </div>
              ) : null}
            </Spin>
          </div>

          {/* {TableForAllList?.length > 0 && (
            <div className="col-md-12 mt-2">
              <div className="button__block mb-4">
                <button
                  className="primary-btn mr-2"
                  onClick={handleDownloadBarChart}
                >
                  {" "}
                  {t("Download Chart")}{" "}
                </button>
              </div>
            </div>
          )}

          <div className="col-lg-12 mt-3">
            <div className="options__div">
              <div className="row mb-4">
                <div className="col-lg-10 rules__div"></div>
                <div className="col-lg-2 crud__div text-end">
                  <Button
                    className="primary-btn"
                    onClick={() => handleExportToCSV("", "", forDealer)}
                    loading={downloadCSVDataloading}
                  >
                    {" "}
                    <i className="fa fa-download"></i> {t("Download CSV")}
                  </Button>
                </div>
              </div>
            </div>
          </div> */}

          <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
            {TableForAllList?.length > 0 && (
              <Button
                className="primary-btn mb-2 mb-lg-0 mr-2"
                onClick={handleDownloadBarChart}
              >
                {" "}
                <i className="fa fa-download"></i> {t("Download Chart")}
              </Button>
            )}
            <Button
              className="primary-btn"
              onClick={() => handleExportToCSV("", "", forDealer)}
              loading={downloadCSVDataloading}
            >
              {" "}
              <i className="fa fa-download"></i> {t("Download CSV")}
            </Button>
          </div>

          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
                scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
              loading={TableForAllLoading}
              columns={[
                {
                  title: (
                    <Tooltip title={t("UserIPAddress")}>
                      {t("UserIPAddress")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "usersIPAddress",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "date",
                  key: "GT.MODIFIED",
                  defaultSortOrder: "descend",
                  sorter: (a, b) => { },
                  render: (item, row) => {
                    return moment(row.date).format("MM-DD-YYYY, hh:mm:ss A");
                  },
                },
                {
                  title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "shape",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "size",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "color",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Cut")}>{t("Cut")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cutGrade",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "clarity",
                  sorter: (a, b) => { },
                  render: (row, item) => {
                    //
                    if (item.clarity) {
                      return (
                        <React.Fragment>
                          <span>{item.clarity}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <Tooltip title={t("Certificate")}>
                      {t("Certificate")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "certificate",
                  sorter: (a, b) => { },
                },
                {
                  title: (
                    <Tooltip title={t("Retailer Price")}>
                      {t("Retailer Price")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "retailPrice",
                  sorter: (a, b) => { },
                  render: (row, item) => {
                    const value = item.retailPrice ? item.retailPrice : "Call For Price";
                    return (
                      <Tooltip title={value}>
                        <span>{value}</span>
                      </Tooltip>
                    );
                  },
                },
                {
                  title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cost",
                  sorter: (a, b) => { },
                  render: (row, item) => {
                    const value = item.cost ? item.cost : "Call For Price";
                    return (
                      <Tooltip title={value}>
                        <span>{value}</span>
                      </Tooltip>
                    );
                  },
                },
              ]}
              dataSource={TableForAllList}
              pagination={{
                size: "small",
                total: totalCount,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
                current: paginationPage,
                onChange: (pageNum) => setPaginationPage(pageNum),
              }}
              onChange={handleTableASCDES}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsShapeIndComp;
